import ReactSelect, { type GroupBase, type Props } from 'react-select'

import chakraTokenToVar from '@/utils/chakraTokenToVar'

export default function Select<
  Option = unknown,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>({ theme: originalTheme, ...props }: Props<Option, IsMulti, Group>) {
  return (
    <ReactSelect<Option, IsMulti, Group>
      {...props}
      theme={theme => ({
        ...theme,
        borderRadius: 0,
        colors: {
          ...theme.colors,
          primary25: chakraTokenToVar('primary.subtle'),
          primary: chakraTokenToVar('primary.solid'),
        },
        ...originalTheme,
      })}
    />
  )
}
